module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.1d77cf80.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-LightItalic.woff
// module id = 535
// module chunks = 0